import { render, staticRenderFns } from "./genre-hero.vue?vue&type=template&id=d33f3a98&scoped=true"
import script from "./genre-hero.vue?vue&type=script&setup=true&lang=js"
export * from "./genre-hero.vue?vue&type=script&setup=true&lang=js"
import style0 from "./genre-hero.vue?vue&type=style&index=0&id=d33f3a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33f3a98",
  null
  
)

export default component.exports